<div class="bg-body position-fixed h-100 w-100 z-index-999">
    <wdx-spinner class="absolute-center"></wdx-spinner>
</div>
